import { Button, Dialog } from '@chakra-ui/react';
import type React from 'react';
import { memo, useRef } from 'react';

interface ConfirmModalProps {
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  isOpen: boolean;
  onClose: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = memo(
  ({
    title = 'Are you sure?',
    message = 'Are you sure you want to do this? This action cannot be undone.',
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    onConfirm,
    onCancel,
    isOpen,
    onClose,
  }) => {
    const cancelRef = useRef<HTMLButtonElement>(null);

    const handleConfirm = () => {
      onConfirm?.();
      onClose();
    };

    const handleCancel = () => {
      onCancel?.();
      onClose();
    };

    return (
      <Dialog.Root open={isOpen} onOpenChange={(e) => !e.open && onClose()} placement="center">
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>{title}</Dialog.Header>
            <Dialog.Body>{message}</Dialog.Body>
            <Dialog.Footer>
              <Button ref={cancelRef} onClick={handleCancel}>
                {cancelLabel}
              </Button>
              <Button colorPalette="red" onClick={handleConfirm} ml={3}>
                {confirmLabel}
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger />
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>
    );
  }
);
